/*
 * Project: LegalPlace assistant
 * File: src\components\title.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


import React, { Component } from 'react';
import { connect } from 'react-redux';
import SaveButton from './save_button2';

export class _BigTitle extends Component {
  constructor(props) {
    super(props);
    if (typeof props.text === 'undefined') props.text = '';
  }

  render() {
    return (
      <h2 ref="title" className="wizard-title" style={{ display: this.props.app_state ? 'flex' : 'none', justifyContent: 'space-between' }}>
        <div>{ this.props.text }</div>
        {(this.props.text !== '') && <SaveButton />}
      </h2>
    );
  }
}

const mapStateToProps = state => ({
  app_state: state.appstate === 0
  || state.appstate === 1
  || state.appstate === 3
  || state.contract.reprise_wizard,
  reprise_wizard: state.contract.reprise_wizard,
});

const mapDispatchToProps = () => ({});

export const BigTitle = connect(mapStateToProps, mapDispatchToProps)(_BigTitle);



// WEBPACK FOOTER //
// ./src/components/title.js